import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
import { clsx } from "clsx";

type Toast = { id: number; tipo: "ok" | "error" | "info"; texto: string };
type Ctx = { ok: (t: string) => void; error: (t: string) => void; info: (t: string) => void };
const ToastCtx = createContext<Ctx | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Toast[]>([]);
  const push = useCallback((tipo: Toast["tipo"], texto: string) => {
    const id = Date.now() + Math.random();
    setItems((xs) => [...xs, { id, tipo, texto }]);
    setTimeout(() => setItems((xs) => xs.filter((x) => x.id !== id)), tipo === "error" ? 7000 : 4000);
  }, []);
  const api = useMemo<Ctx>(() => ({ ok: (t) => push("ok", t), error: (t) => push("error", t), info: (t) => push("info", t) }), [push]);
  return (
    <ToastCtx.Provider value={api}>
      {children}
      <div className="pointer-events-none fixed inset-x-0 bottom-20 z-50 flex flex-col items-center gap-2 px-4 md:bottom-6" aria-live="polite">
        {items.map((t) => (
          <div key={t.id} className={clsx("pointer-events-auto max-w-md rounded-md px-4 py-3 text-sm shadow-lg",
            t.tipo === "ok" && "bg-emerald-700 text-white", t.tipo === "error" && "bg-red-700 text-white", t.tipo === "info" && "bg-primary text-white")}>{t.texto}</div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast(): Ctx {
  const c = useContext(ToastCtx);
  if (!c) throw new Error("useToast fuera de ToastProvider");
  return c;
}
